import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import { Icon, type IconName } from '../icons';
import type { COLORS } from '../Typography/Typography';
import { useButton } from './context/useButton';
type Props = {
  className?: string;
  name: IconName;
  color?: keyof typeof COLORS | string; // 기본 currentColor
  iconSize?: number; // 강제 오버라이드
};
export const ButtonIcon = t0 => {
  const $ = _c(8);
  const {
    className,
    name,
    color,
    iconSize
  } = t0;
  const {
    height
  } = useButton();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      h56: 20,
      h48: 16,
      h40: 16,
      h32: 16,
      h28: 16,
      small: 16,
      medium: 16
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const map = t1 as const;
  const IconSize = iconSize ?? map[height];
  let t2;
  if ($[1] !== className) {
    t2 = cn("inline-flex shrink-0 items-center justify-center", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = color ?? "currentColor";
  let t4;
  if ($[3] !== IconSize || $[4] !== name || $[5] !== t2 || $[6] !== t3) {
    t4 = <Icon eager={true} name={name} aria-hidden="true" className={t2} color={t3} size={IconSize} />;
    $[3] = IconSize;
    $[4] = name;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};